import {fetchJSON} from "../utils/fetch";
import {Service, service, inject} from "./di";
import {ConfigService} from "./ConfigService";
import MetadataService from "./MetadataService";
import {Backflipp} from "./BackflippService";
import {LocationService} from "./LocationService";
import {FlyerService} from "./FlyerService";
import {slugify} from "../utils/slugify";
import {FlyerMetadataJSON, MerchantsDetails} from "../definitions/BackflippDefinitions";

@service
export default class MerchantService extends Service {
	@inject configService: ConfigService;
	@inject metadataService: MetadataService;
	@inject backflippService: Backflipp;
	@inject flyerService: FlyerService;
	@inject locationService: LocationService;

	/**
	 * Takes the category with the most flyers and returns only premium flyers
	 * If there is not premium in the top, it takes the next category
	 */
	public async getTopCategoryPremiumFlyers(): Promise<FlyerMetadataJSON[]> {
		const { flyers } = await this.flyerService.getFlyersDataJSON(this.locationService.postalCode);
		const categories = await this.flyerService.getCategories();
		const sortedCategories = [...categories].sort((a, b) => a.count - b.count).slice(0, categories.length - 2);
		let filteredFlyers: FlyerMetadataJSON[] = [];
		while (filteredFlyers.length === 0 && sortedCategories.length > 0) {
			const topCategory = sortedCategories.pop();
			filteredFlyers = flyers.filter(flyer => flyer.categories.includes(topCategory.name) && flyer.premium === true);
		}
		return filteredFlyers;
	}

	public async getMerchantDetails(merchantIds: string): Promise<MerchantsDetails> {
		try {
			return await fetchJSON<MerchantsDetails>(`${this.configService.GATEFLIPP_SERVER}/flipp/merchants/details?ids=${merchantIds}`);
		} catch (e) {
			return null;
		}
	}
}
